<template>
    <div class="bg">
        <span :class="{ '.active' : isSidebarActive }" @click.prevent="sideBarToggle"><font-awesome-icon icon="id-card" /></span>
    </div>
</template>


<script>
    import { store, mutations } from "../../store.js";
    export default {
        name: "Bio",
        computed: {
            isSidebarActive() {
                return store.isSidebarShowing;
            }
        },
        methods: {
            sideBarToggle() {
                mutations.toggleBar();
            }
        }
    }
</script>

<style scoped>
    span {
        color: navy;
        text-align: center;
        font-size: 20px;
        cursor: pointer;
        z-index: 99;
        position: relative;
        margin-left: 3px;
    }
    span::after {
        position: absolute;
        content: "";
        display: block;
        height: 50px;
        width: 50px;
        top: -10px;
        left: -13px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.2);
        z-index: -1;
    }
    span:hover::after {
        background: white;
    }
    span:hover {
        color: blue;
    }
    span:active {
        color: red;
        z-index: 999;
    }
</style>